export default __webpack_public_path__ + "static/old-space-6e5c657510a295bfe43f2b70d2d1f08e.jpeg";